/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CustomerDeclarationDto { 
    deviceDescription: string;
    option: CustomerDeclarationDto.OptionEnum;
    performanceDescription?: string;
    itemId?: string;
}
export namespace CustomerDeclarationDto {
    export const OptionEnum = {
        Refurbish: 'REFURBISH',
        Store: 'STORE',
        Dispose: 'DISPOSE'
    } as const;
    export type OptionEnum = typeof OptionEnum[keyof typeof OptionEnum];
}


